export default __webpack_public_path__ + "static/epson-668d02d42f52b409c7fafb5f35eeecb9.png";